import { render, staticRenderFns } from "./UpcommingAuctionsTable.vue?vue&type=template&id=237a9d3c"
import script from "./UpcommingAuctionsTable.vue?vue&type=script&lang=js"
export * from "./UpcommingAuctionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports